import { createRoot } from "react-dom/client";
import { PrivyProvider } from "@privy-io/react-auth";
import { App } from "./App";

const appId = process.env.BUN_PUBLIC_PRIVY_APP_ID;

function PrivyWrapper({ children }: { children: React.ReactNode }) {
  if (!appId) {
    throw new Error("Missing BUN_PUBLIC_PRIVY_APP_ID environment variable");
  }

  return (
    <PrivyProvider
      appId={appId}
      config={{
        embeddedWallets: {
          ethereum: {
            createOnLogin: "off",
          },
          solana: {
            createOnLogin: "off",
          },
        },
        loginMethods: ["email"],
        appearance: {
          accentColor: "#000000",
          theme: "light",
          landingHeader: "Confirm your Goldsand email"
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
}

function Root() {
  const normalizedPath = window.location.pathname.toLowerCase().replace(/\/$/, "");
  const needsPrivy = ["/export-wallet", "/support"].includes(normalizedPath);

  if (needsPrivy) {
    return (
      <PrivyWrapper>
        <App />
      </PrivyWrapper>
    );
  }

  return <App />;
}

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<Root />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
